
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { UserService } from '@/services/index'
import { roleOptions } from '@/constants/role'

@Component({
    components: {
    }
})
export default class extends Vue {
    private userRules = {
        name: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, message: '密码不能少于6个字符', trigger: 'blur' }
        ]
    }
    private userForm: any = {
        name: '',
        password: '',
        role: 1
    }
    private roleOptions = roleOptions
    private loading: boolean = false

    private onCreate() {
        (this.$refs.userForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.loading = true
                const { name, password, mobile, role, email, department } = this.userForm
                const params = { name, password, mobile, role, email, department }
                const result = await UserService.createUser(params)
                if (result.status === 200) {
                    (this.$refs.userForm as ElForm).resetFields()
                    this.$message({ type: 'success', message: '创建成功' })
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.loading = false
            } else {
                return false
            }
        })
    }

    private onCancel() {
        this.$router.go(-1)
    }
}
